<div *ngIf="!selectedChartType && pageType !== 'selfService'">
  <div class="chart align-items-center justify-content-center d-flex chart-select">
    Please select {{pageType === 'selfService' ? 'vehicles' : 'values'}} to generate chart!
  </div>
</div>
<div class="attr-chart-container d-flex flex-column gap20 h-100"  *ngIf="selectedChartType">
    <div *ngIf="isloader && !hideStatistics && pageType !== 'selfService'" class="h-100 w-100 padt-5">
      <mat-progress-bar [mode]="'indeterminate'">
      </mat-progress-bar>
    </div>
    <div class="d-flex flex-column chart-area h-100" [ngClass]="{'d-flex align-items-center justify-content-center': loaderStopped }">
      <!-- <div class="attr-title">{{chartAttributes?.yAxis?.attributeName ?? chartAttributes?.yAxis?.name}}<span class="att-uom" *ngIf="chartAttributes?.yAxis?.uom">&nbsp;&nbsp;{{chartAttributes?.yAxis?.uom}}</span>
      </div> -->
      <div class="d-flex flex-column split-count gap20"  *ngIf="!hideStatistics && pageType !== 'selfService'">
        <div class="attr-title">Statistics</div>
        <div>{{chartAttributes?.yAxis?.attributeName}}<span class="att-uom" *ngIf="chartAttributes?.yAxis?.uom">&nbsp;&nbsp;{{chartAttributes?.yAxis?.uom}}</span></div>
        <div class="d-flex gap20" *ngIf="selectedChartType && service.rbacManagement('vehicles_Enrolled_AnalyticsFramework_StatisticsFields') && statsSplitY1?.length">
          <div class="stat-box d-flex flex-column" *ngFor="let stat of statsSplitY1; let i = index"
            [ngClass]="{'alt-box1': (i%2)===0,'alt-box2': (i%2)!==0}">
            <span class="attr-ellipsis stat-name" [matTooltip]="stat?.name">{{stat?.name}}</span>
            <span class="attr-ellipsis stat-value" *ngIf="stat?.value||stat?.value===0"
              [matTooltip]="stat?.value?.toString()">{{ stat?.value }}</span>
            <span *ngIf="!stat?.value && stat.value !== 0" class="stat-value-no-data">No Data</span>
          </div>
        </div>
        <div>{{chartAttributes?.yAxis2?.attributeName}}<span class="att-uom" *ngIf="chartAttributes?.yAxis2?.uom">&nbsp;&nbsp;{{chartAttributes?.yAxis2?.uom}}</span></div>
        <div class="d-flex gap20" *ngIf="selectedChartType && service.rbacManagement('vehicles_Enrolled_AnalyticsFramework_StatisticsFields') && statsSplitY2?.length">
          <div class="stat-box d-flex flex-column" *ngFor="let stat of statsSplitY2; let i = index"
            [ngClass]="{'alt-box1': (i%2)===0,'alt-box2': (i%2)!==0}">
            <span class="attr-ellipsis stat-name" [matTooltip]="stat?.name">{{stat?.name}}</span>
            <span class="attr-ellipsis stat-value" *ngIf="stat?.value||stat?.value===0"
              [matTooltip]="stat?.value?.toString()">{{ stat?.value }}</span>
            <span *ngIf="!stat?.value && stat.value !== 0" class="stat-value-no-data">No Data</span>
          </div>
        </div>
      </div>
      <!--Chart component-->
      <!-- <div class="chart" *ngIf="!selectedChartType">
        Please select values to generate chart!
      </div> -->
      <div class="h-100 w-100" *ngIf="!loaderStopped">
        <div class="chart" [ngSwitch]="selectedChartType">
          
          <!-- Loader -->
          <div *ngIf="isloader" class="loader-overlay">
            <div class="loader-circle">
              <mat-progress-spinner
                mode="indeterminate"
                diameter="40"
                strokeWidth="3"
                color="primary">
              </mat-progress-spinner>
              <button class="stop-btn" (click)="stopLoading()">■</button>
            </div>
          </div>
          
          <!-- Chart View -->
          <ng-container *ngIf="!isloader && !switchToTable">
            <app-line-echart *ngSwitchCase="'line'" class="echart"
              [xAxis]="chartData?.xAxis" [tooltip]="chartData?.tooltip" [yAxis]="chartData?.yAxis"
              [series]="chartData?.series" [grid]="chartData?.grid" [toolbox]="chartData?.toolbox"
              [title]="chartData?.title" [legend]="chartData?.legend" (dataZoom)="dataZoom($event)">
            </app-line-echart>
      
            <app-double-axis-line-echart *ngSwitchCase="'doubleY'" class="echart"
              [xAxis]="chartData?.xAxis" [tooltip]="chartData?.tooltip" [yAxis]="chartData?.yAxis"
              [series]="chartData?.series" [grid]="chartData?.grid" [toolbox]="chartData?.toolbox"
              [title]="chartData?.title" (dataZoom)="dataZoom($event)" [legend]="chartData?.legend">
            </app-double-axis-line-echart>
      
            <app-scatter-echart *ngSwitchCase="'scatter'" class="echart"
              [xAxis]="chartData?.xAxis" [tooltip]="chartData?.tooltip" [yAxis]="chartData?.yAxis"
              [series]="chartData?.series" [grid]="chartData?.grid" [toolbox]="chartData?.toolbox"
              [title]="chartData?.title" (dataZoom)="dataZoom($event)" [legend]="chartData?.legend">
            </app-scatter-echart>
      
            <app-double-axis-scatter-echart *ngSwitchCase="'doubleScatter'" class="echart"
              [xAxis]="chartData?.xAxis" [tooltip]="chartData?.tooltip" [yAxis]="chartData?.yAxis"
              [series]="chartData?.series" [grid]="chartData?.grid" [toolbox]="chartData?.toolbox"
              [title]="chartData?.title" (dataZoom)="dataZoom($event)" [legend]="chartData?.legend">
            </app-double-axis-scatter-echart>
          </ng-container>
      
          <!-- Table View -->
          <ng-container *ngIf="!isloader && switchToTable">
            <div class="d-flex justify-space-between">
              <div class="icons table-title justify-content-center align-items-center">
                {{chartAttributes?.name}}
              </div>
              <div class="d-flex justify-content-end gap20 icons">
                <div>
                  <img class="chart-icon cursor" src="../../../../../../assets/images/chart-icon.svg"
                       alt="Chart view" matTooltip="Switch to Chart" (click)="switchToTable=false">
                </div>
                <!-- <div>
                  <img src="../../../../assets/images/download-VOT.svg" matTooltip="Download"
                       alt="Download" class="export-h-43 cursor" (click)="exportToExcel()">
                </div> -->
                <app-export [ngClass]="{'disabled': !chartDataMaster?.length}" (exportAction)="exportEvent($event)"></app-export>
              </div>
            </div>
              <app-common-table class="app-common-table"
                [tableData]="chartDataMaster"
                [columnHeader]="columnHeader"
                [pageType]="'chart-builder'"
                [actionPermission]="{ pagination: true }"
                (tableRendered)="onTableRendered()">
              </app-common-table>
          
          </ng-container>
      
        </div>
      </div>
      <div *ngIf="loaderStopped" class="d-flex align-items-center justify-content-center">
        <div>Loading canceled</div>
      </div>
      <div *ngIf="loaderStopped" class="d-flex align-items-center justify-content-center" (click)="reloadApi()">
        <img src="../../../../assets/images/refresh-icon-s.svg"
                title="Reload API" class="h-14 cursor" alt="Api reload">
      </div>
      
    </div>
    <!-- <div *ngIf="!isloader && !attributeData" class="text-center">
      <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="no data">
    </div> -->
  </div>